import type { Faq } from "@components/Faq.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getDigitalizationAndAutomationPath } from "@core/schema/paths/getDigitalizationAndAutomationPath.js";

export function getFaqsMobileApps(tenant: Tenant): Faq[] {
	return [
		{
			question: "Jak zjistím, jestli potřebuji jen webovou, nebo i mobilní aplikaci?",
			answer:
				"Na začátku projdeme vaše požadavky a představy a podle toho vám pomůžeme určit, jestli potřebujete jen webovou, nebo i mobilní aplikaci. Často s klienty přijdeme na to, že si vystačí pouze s webovou aplikací, což jim ušetří spoustu nákladů. ",
		},
		{
			question: "Jak dlouho trvá vývoj mobilní aplikace na míru?",
			answer:
				"Záleží na konkrétním zadání. Vývoj mobilní aplikace bývá zpravidla náročnější než u webové aplikace, první verzi (MVP) obvykle dodáváme v rozmezí 3 až 6 měsíců.",
		},
		{
			question: "Můžete do mobilní aplikace zapracovat funkce, které potřebujeme?",
			answer:
				"Ano, rádi do aplikace zapracujeme funkce jako push notifikace, GPS, platební bránu nebo biometrické ověření totožnosti (např. Face ID).",
		},
		{
			question: "Dáváte pevné ceny, nebo fungujete na základě hodinové sazby?",
			answer: "Oba přístupy jsou možné, vždy záleží na podobě daného projektu a na potřebách klienta.",
		},
		{
			question: "Jak v případě problémů probíhá záloha a obnova dat?",
			answer:
				"Data z mobilní aplikace se zpravidla ukládají do cloudové databáze. Výjimkou je offline režim nebo jiná dodatečná data.",
		},
		{
			question:
				"Kromě přípravy aplikace na míru potřebujeme i digitalizovat a automatizovat některé procesy ve firmě. Poradíte si s tím?",
			answer: `Ano, klientům běžně pomáháme [${getDigitalizationAndAutomationPath(
				tenant,
			)}][[digitalizovat a automatizovat]] rutinní procesy napříč podnikáním.`,
		},
	];
}
